import React, { useMemo } from "react";
import Select from "react-select";
import { useFormikContext, ErrorMessage } from "formik";
import { useGetAgenciesQuery } from "../services/redux/api/components";

const AgencyDropdown = ({ name = "Agency", pageNumber = 1, pageSize = 100 }) => {
  const { setFieldValue, values } = useFormikContext();

  // Fetch agencies using RTK Query
  const { data: Agency, isLoading, isFetching, error } = useGetAgenciesQuery({
    pageNumber,
    pageSize,
  });

  // Normalize and map agency data
  const rowData = useMemo(() => {
    if (!Agency?.data || !Array.isArray(Agency.data)) return [];
    return Agency.data.map((item) => ({
      value: item.AgencyID ?? item.id ?? item.AgencyId ?? "",
      label: item.AgencyName ?? item.Name ?? item.DisplayName ?? `#${item.AgencyID}`,
    }));
  }, [Agency]);

  const selectedValue = rowData.find((opt) => opt.value === values[name]) || null;

  const handleChange = (selectedOption) => {
    setFieldValue(name, selectedOption ? selectedOption.value : "");
  };

  return (
    <div className="px-2">
      <label className="form-label">
        Agency
      </label>

      <Select
        name={name}
        options={rowData}
        isLoading={isLoading || isFetching}
        value={selectedValue}
        onChange={handleChange}
        placeholder={isLoading || isFetching ? "Loading agencies..." : "Select"}
        isClearable
        isSearchable
        classNamePrefix="react-select"
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
            border: state.isFocused ? "1px solid #EB2B21" : "1px solid #D1D5DB",
            borderRadius: "10px",
            padding: "2px 2px",
            fontSize: "14px",
            outline: "none",
            "&:hover": {
              borderColor: state.isFocused ? "#EB2B21" : "#9ca3af",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "10px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
          }),
        }}
      />

      <ErrorMessage name={name} component="div" className="text-red-600 text-sm mt-1" />
    </div>
  );
};

export default AgencyDropdown;
